<alaris-icon
	[name]="campaign.setup.channels.length > 1 ? 'icon-Multi-plan-v2' : cu.icon(campaign.setup.channels[0].trafficType)"
	class="icon"
></alaris-icon>

<div class="name">{{ campaign.info.name }}</div>

<div class="content">
	@if (campaign.setup.native) {
		@if (campaign.setup.channels[0].message?.templateID) {
			<button
				(click)="navigateToTemplate(campaign.setup.channels[0].message?.templateID)"
				class="file"
				data-testid="exportBtn"
			>
				<alaris-icon name="icon-file-text"></alaris-icon>
				{{ (campaign.setup.channels[0].message?.templateID ?? 0 | message)?.name }}
			</button>
		} @else {
			<div
				[maxWidth]="250"
				[alarisTooltip]="campaign.setup.channels[0].message?.text ?? ''"
				[overflow]="true"
				class="message"
			>
				{{ campaign.setup.channels[0].message?.text ?? '' }}
			</div>
		}
	}
	@if (campaign.setup.file) {
		@if (campaign.setup.file) {
			<button
				(click)="export(campaign.setup.file.file.id, campaign.setup.file.file.name)"
				class="file"
				data-testid="exportBtn"
			>
				<alaris-icon name="icon-attach"></alaris-icon>
				{{ campaign.setup.file.file.name }}
			</button>
		}
	}
</div>
